import React from 'react';

const ErrorIcon = ({ className = "", size = "lg" }) => {
  // تحديد الحجم بناءً على المعلمة size
  const sizeMap = {
    sm: "w-8 h-8",
    md: "w-12 h-12",
    lg: "w-16 h-16",
    xl: "w-24 h-24",
    "2xl": "w-32 h-32"
  };

  const sizeClass = sizeMap[size] || sizeMap.lg;

  return (
    <div className={`${sizeClass} ${className}`}>
      <svg
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="w-full h-full"
      >
        <circle cx="12" cy="12" r="12" className="fill-current text-red-100" />
        <circle cx="12" cy="12" r="9" className="fill-current text-red-500" />
        <path
          d="M15.5355 8.46447L8.46447 15.5355M8.46447 8.46447L15.5355 15.5355"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>
    </div>
  );
};

export default ErrorIcon;